// Add explicit import to ensure correct package name in declaration files

import useModelContext from './useModelContext';
export default function useCurrentAuth() {
  const auth = useModelContext(s => s.auth);
  return auth;
}